import { Component } from '@angular/core';

import { TableFieldService } from '@module-definition/table-field/common';
import { TableFieldComponent } from '@module-definition/table-field/table-field.component';
import { FieldDefinitionService } from '@module-instance/services/field-definition.service';
import { CipoControl, CipoFieldTypes, CipoTableConfig } from '@shared/components/fields/common';
import { DemoFieldDefinitionService } from './demo-field-definition.service';

@Component({
  selector: 'app-demo-table-field',
  template: `
    <div class="p-a-xl">
      <cipo-table-field [control]="tableControl" tableFieldId="123" />
    </div>
  `,
  imports: [TableFieldComponent],
  providers: [{ provide: FieldDefinitionService, useClass: DemoFieldDefinitionService }, TableFieldService],
})
export class DemoTableFieldComponent {
  tableControl = new CipoControl<null, CipoTableConfig>(null, {
    type: CipoFieldTypes.Table,
  });
}
